import i18n from 'l10n';
import UserModel from 'js/models/userrelatedinfo.model';
import BaseView from 'js/views/subscribers.base.view';
import SubscribersCollection from 'js/models/subscribers.collection';
import RowView from 'js/views/subscriber.list.row.view';
import Template from 'js/templates/subscribers.list.hbs';
import {debounce, domain, el, on, tagName, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');
require('metroHelpers');

@el("#group-contacts-container")
@tagName('span')
@domain('.page')
@template(Template)
class SubscribersListView extends BaseView {

    currentSelectedSubscriptionId = -1;
    superInitialize = BaseView.prototype.initialize;

    @on('keyup .searchbox')
    dosearch() {
        super.dosearch();
    }

    constructor(options) {
        super(options);
        const self = this;
        this.options = options;
        this.inGroupContactsSearch = true;
        this.groupModel = self.options.groupModel;
        this.groupModel.bind("change", this.renderView.bind(this, true), this);
        this.SubscriberView = RowView;
        this.subscribersCollection = new SubscribersCollection();
        this.subscribersUrl = this.subscribersCollection.url;
        this.subscribersCollection.url = this.groupModel.getSubscribersCollectionUrl();

        this.userModel = new UserModel();
        this.userModel.fetch({
            error: console.error
        });
    }

    renderView(dontRender) {
        super.renderView(dontRender);
        if (this.groupModel.get("groupType") === "query") {
            this.$('#insert-contact-control').hide();
        }
    }

    hide() {
        this.$el.parent().parent().hide();
    }

    show() {
        this.$el.parent().parent().show();
    }

    modelRendering(model, el) {
        model.set("postpaid", this.userModel.get("postpaid"));
        const view = new this.SubscriberView({model: model, groupModel: this.groupModel});
        view.render();
        const elInner = view.el;
        $(el).html('');
        $(el).append(elInner);
    }

    newSubscriberView(model) {
        return new this.SubscriberView({model: model, groupModel: this.groupModel});
    }

    @debounce(300)
    @on('keyup #addExistingContactToGroup')
    searchForExistingContact() {
        if (this.currentSelectedSubscriptionId !== -1) {
            this.currentSelectedSubscriptionId = -1;
            $("#insertContact").attr("disabled", true);
        }

        console.info("Fetching contacts");
        const $addExistingContactToGroup = $("#addExistingContactToGroup");
        if (!$addExistingContactToGroup.val()) {
            this.currentSelectedSubscriptionId = -1;
            $("#searchOptions").css("display", "none");
            return;
        }

        const formValues = {
            filter: $addExistingContactToGroup.val()
        };

        $.ajaxDefaultQ({
            url: '/CampaignCloud/Subscription/getSubscriptionsWithFilter',
            type: 'GET',
            data: formValues,
            dataType: "json"
        }).done(function (response) {
            const $searchOptions = $('#searchOptions');
            $searchOptions.html("");
            $searchOptions.css("display", "block");
            $searchOptions.append($('<option>', {
                disabled: true,
                selected: true,
                style: "text-align: center !important",
                id: "defaultOption",
                value: "",
                text: "---- 0 " + i18n.t("groups.resultsfound") + " ----"
            }));

            let foundCount = 0;
            const allSubs = response;
            for (var i = 0; i < allSubs.length; i++) {
                // var value = $("#addExistingContactToGroup").val();

                const subId = allSubs[i].subscriptionId;
                const msisdn = allSubs[i].msisdn;
                const sub = allSubs[i].subscriber;
                const firstName = sub.firstName;
                const lastName = sub.lastName;
                const email = sub.email;

                const infoToShow = sub
                    ? (lastName ?
                        lastName + " " + firstName :
                        (firstName ?
                            firstName :
                            (email ?
                                email :
                                msisdn)))
                    : msisdn;


                $searchOptions.append($('<option>', {
                    value: subId,
                    text: infoToShow
                }));
                foundCount++;
            }
            setTimeout(function () {
                $.getDefaultJSONQ("/CampaignCloud/Subscription/getSubscriptionsWithFilterCount", formValues, function (json) {
                    var $searchOptions2 = $('#searchOptions');
                    if (json > 10 && foundCount === 10) {
                        $searchOptions2.append($('<option>', {
                            disabled: true,
                            value: "",
                            text: "…"
                        }));
                        $("#defaultOption").text("━━ " + foundCount + " " + i18n.t("groups.n_results_of") + " " + json + " ━━");
                    } else {
                        $("#defaultOption").text("━━ " + foundCount + " " + i18n.t("groups.resultsfound", {count: foundCount}) + " ━━");
                    }

                    $searchOptions2.attr("size", parseInt($('#searchOptions > option').length));
                });
            }, 0);
        })
            .fail(function (response) {
                console.info(response);
            });
    }

    @on('click #searchOptions option')
    changeValue(event) {
        this.currentSelectedSubscriptionId = event.target.value;
        $("#addExistingContactToGroup").val(event.target.innerHTML);
        $("#searchOptions").css("display", "none");
        if (this.currentSelectedSubscriptionId !== -1) {
            $("#insertContact").attr("disabled", false);
        } else {
            $("#insertContact").attr("disabled", true); //not necessary
        }
    }

    @on('click #insertContact')
    addContactToGroup() {
        const sId = this.currentSelectedSubscriptionId;
        this.groupModel.addContactToGroup(sId);
    }

    @on('change #filterBounce input[type="radio"]')
    onRadioSelectionChange(event) {
        const selectedValue = event.target.value;

        super.doFilterBounce(selectedValue);
    }
}

export default SubscribersListView;
